import React, { useEffect } from "react";
import { Link } from "react-router-dom"; // Ensure you have react-router-dom installed
import useServices from "../../useHook/useServices";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import ServicesItem from "./ServicesItem";
import "./Services.css";

const Services = ({ home }) => {
  const [services] = useServices();

  useEffect(() => {
    if (!home) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [home]);

  return (
    <>
      {!home && <Breadcrumbs title="Unsere Leistungen" />}

      <div className="bg-white">
        <div className="container services-container pb-16 pt-12 px-2">
          <div className="text-center pt-6">
            {home ? (
              <h1 className="text-4xl pb-2 font-Poppins font-semibold">
                Unsere <span className="text-primary">Leistungen</span>
              </h1>
            ) : (
              <h1 className="text-4xl py-2 font-Poppins font-semibold">
                Unsere <span className="text-primary">Leistungen</span>
              </h1>
            )}

            <p className="font-Roboto pt-2 pb-6">
              Gute Mundgesundheit erfordert mehr als nur tägliches Zähneputzen. Befolgen Sie wichtige Schritte für ein lebenslang gesundes Lächeln. Vertrauen Sie op onze expertise in de tandheelkundige zorg.
            </p>
          </div>
          <div className="flex w-full justify-center">
            <div className="grid lg:grid-cols-4 sm:grid-cols-2 md:grid-cols-3 grid-cols-1 gap-8">
            {services.length > 0 && home
              ? services.slice(0, 8).map((service) => (
                  <ServicesItem key={service.id} service={service} />
                ))
              : services.map((service) => (
                  <ServicesItem key={service.id} service={service} />
                ))}
          </div>
          </div>
          
          {home && (
            <div className="text-center pt-6">
              <Link to="/services" className="see-all-button bg-primary rounded-xl">
                Alles Anzeigen
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Services;
